import { useTranslation } from "react-i18next"
import { FormCancelActionStyle } from "overrides/theme/entel/base/pages/DetailOrderScreens/styles/OrderDetailModalAction.style"
import { useForm } from "react-hook-form"
import { useEffect, useState } from "react"
import UseGetScheduleOrder from "hooks/UseGetScheduleOrder"
import { formatDate } from "helpers/FormatDateHelper"

export const FormRescheduleAction = ({ close, confirmAction, data, reschedule_data }: any) => {
  const { register, handleSubmit, watch } = useForm<any>({ defaultValues: { date: "" } })
  const [loading_schedule, setLoadingSchedule] = useState(true)
  const [availableDates, setAvailableDates] = useState<any[]>([])
  const { getScheduleOrder } = UseGetScheduleOrder()
  const date = watch("date")

  useEffect(() => {
    const fetchDates = async () => {
      try {
        setLoadingSchedule(true)
        let _body: any = {
          channel: data?._sg?.channel,
          originalOderId: data?._sg?.salesChannelId,
          shippingType: [data?._sg?.shippingType],
          items: data?._items?.map((__item: any) => ({ sku: __item?.sku, quantity: __item?.quantity })),
        }
        if (data?._sg?.shippingType === "HD") {
          _body = {
            ..._body,
            shippingAddress: {
              country: data?._order?.shippingAddress?.country,
              region: data?._order?.shippingAddress?.region,
              location: {
                // ...data?._order?.shippingAddress,
                province: data?._order?.shippingAddress.province || "",
                commune: data?._order?.shippingAddress.commune || "",
                address: `${data?._order?.shippingAddress.addressName || ""} ${
                  data?._order?.shippingAddress.addressNumber || ""
                }`,
                latitude: data?._order?.shippingAddress.georeference.latitude || "",
                longitude: data?._order?.shippingAddress.georeference.longitude || "",
              },
            },
            contact: {
              name: data?._order?.shippingAddress.contact.name || "",
              email: data?._order?.shippingAddress.contact.email || "",
              phone: data?._order?.shippingAddress.contact.phone || "",
            },
          }
        }
        const res: any = await getScheduleOrder(_body)
        if (res?.data?.message?.shippingType) {
          const dates = getAvailableDatesByDeliveryType(res.data.message, data?._sg?.deliveryType)
          setAvailableDates(dates)
          reschedule_data.dispatch({ ...reschedule_data.state, transactionIdSchedule: res.data.transactionId })
        }
        setLoadingSchedule(false)
      } catch (error) {
        setLoadingSchedule(false)
        console.error("Error fetching dates:", error)
      }
    }
    fetchDates()
    // eslint-disable-next-line
  }, [data])

  useEffect(() => {
    if (date) {
      reschedule_data.dispatch({ ...reschedule_data.state, date: date })
    }
    // eslint-disable-next-line
  }, [date])

  const getAvailableDatesByDeliveryType = (data: any, deliveryType: string) => {
    const dates = []

    const shippingTypes = data?.shippingType?.HD || []

    for (const option of shippingTypes) {
      for (const schedule of option.schedules || []) {
        if (schedule?.deliveryType === deliveryType) {
          for (const date of schedule?.dates || []) {
            dates.push({
              label: formatDate(date.delivery),
              value: date.delivery,
            })
          }
        }
      }
    }

    return dates || []
  }

  return (
    <>
      <form className="form_cancel_action__main" onSubmit={handleSubmit(confirmAction)}>
        {loading_schedule ? (
          <h3 className="order_detail_modal_action__cont_title_descr">Obteniendo nuevas fechas, espere...</h3>
        ) : (
          <>
            {availableDates?.length ? (
              <select {...register("date")} className="form_cancel_action__input_form form_cancel_action__select_form">
                <option value="" selected disabled>
                  Seleccione fecha de reagendamiento...
                </option>
                {availableDates?.map((date: any, i: number) => (
                  <option key={i} value={date.value}>
                    {date.label}
                  </option>
                ))}
              </select>
            ) : (
              <p className="order_detail_modal_action__cont_title_descr">No hay fechas disponibles</p>
            )}
            <div className="order_detail_modal_action__cont_buttons">
              <button type="button" className="order_detail_modal_action__btn_no" onClick={close}>
                No
              </button>
              <button
                disabled={Boolean(!date)}
                className="order_detail_modal_action__btn_yes"
                type="button"
                onClick={() => {
                  confirmAction()
                  close()
                }}
              >
                {`Si, Reagendar Orden`}
              </button>
            </div>
          </>
        )}
      </form>

      <style jsx>{FormCancelActionStyle}</style>
    </>
  )
}

export const FormCancelAction = ({ close, action, status, confirmAction, cancel_reasons, set_reason_cancel }: any) => {
  const { t } = useTranslation()
  const { register, watch } = useForm<any>()
  const cancel_reason = watch("reason")

  useEffect(() => {
    cancel_reason && set_reason_cancel(cancel_reason)
    // eslint-disable-next-line
  }, [cancel_reason])

  const is_there_cancel_options = Boolean(cancel_reasons?.length)

  return (
    <>
      <form className="form_cancel_action__main">
        {is_there_cancel_options ? (
          <select {...register("reason")} className="form_cancel_action__input_form form_cancel_action__select_form">
            <option value="" selected disabled>
              Seleccione motivo de cancelación...
            </option>
            {cancel_reasons.map((reason: any, i: number) => (
              <option key={i} value={reason.value}>
                {reason.label}
              </option>
            ))}
          </select>
        ) : null}
        <div className="order_detail_modal_action__cont_buttons">
          <button type="button" className="order_detail_modal_action__btn_no" onClick={close}>
            No
          </button>
          <button
            disabled={Boolean(!cancel_reason)}
            className="order_detail_modal_action__btn_yes"
            type="button"
            onClick={() => {
              confirmAction()
              close()
            }}
          >
            {`Si, ${
              status === "IN_TRANSIT" && action.action === "cancel" ? "Retornar y cancelar" : t(`${action.action}`)
            } Orden`}
          </button>
        </div>
      </form>
      <style jsx>{FormCancelActionStyle}</style>
    </>
  )
}
